import {
  createMaxMessage,
  createMinMessage,
  createRequiredMessage,
} from '@domain/validations';
import * as Yup from 'yup';

const nextDay = new Date();
nextDay.setDate(nextDay.getDate() + 1);
nextDay.setHours(0, 0, 0, 0);

export const getAssignmentValidationSchema = () => {
  const AssignmentValidationSchema = Yup.object<any>().shape({
    title: Yup.string()
      .min(3, createMinMessage('title', 3))
      .max(300, createMaxMessage('title', 300))
      .required(createRequiredMessage('Title')),
    description: Yup.string()
      .min(0, createMinMessage('description', 0))
      .max(100, createMaxMessage('description', 1000))
      .optional(),
    endDate: Yup.date().nullable(),
  });

  return AssignmentValidationSchema;
};
